import { queryGraphQL,mutateGraphQL } from 'common/util/query';
import { toMutation, toQuery, nodeWithArgs, node } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import {
    loadStudySignatures,
    loadSignatureExpectations,
} from './studySignatures';
import {
    retrieveStudyAuditLogData,
} from './studyAuditLog';
import { binderInstitutionIdSelector } from 'common/selectors';
import { studyNodeWrapper } from 'common/util/studyQueryHelper';

export const LOAD_STUDY_DELEGATIONS = 'LOAD_STUDY_DELEGATIONS';
export const ADD_STUDY_DELEGATION = 'ADD_STUDY_DELEGATION';
export const UPDATE_STUDY_DELEGATION = 'UPDATE_STUDY_DELEGATION';
export const DELETE_STUDY_DELEGATION = 'DELETE_STUDY_DELEGATION';
export const UNLOAD_STUDY_TASKS_AND_DELEGATIONS = 'UNLOAD_STUDY_TASKS_AND_DELEGATIONS';

export function loadStudyDelegations(binderId) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        dispatch({
            type: 'LOADING_DELEGATIONS',
            payload: null,
        });
        const query = nodeWithArgs('studyDelegations', {
            binderId,
            institutionId,
        }, [
            'id',
            node('user', [
                'id',
                'displayName',
                'emailAddress',
            ]),
            node('rolesManagement', ['id', 'name']),
            'taskIds',
            'startDate',
            'endDate',
            'createdAt',
        ]);

        return queryGraphQL(toQuery(query)).then(results => {
            const { studyDelegations } = results.data;
            dispatch(
                loadStudyDelegationsAction(studyDelegations)
            ).then(dispatch(loadStudySignatures(binderId)));
        });
    };
}

export function loadStudyDelegationsAction(studyDelegations) {
    return {
        type: LOAD_STUDY_DELEGATIONS,
        payload: studyDelegations
    };
}

export function addStudyDelegation(binderId, delegation) {
    return (dispatch, getState) => {
        const state = getState();
        const { study: { id: studyId } = {} } = state;
        const institutionId = binderInstitutionIdSelector(state);
        dispatch({
            type: 'LOAD_DELEGATION',
        });
        const query = studyNodeWrapper(
            studyId,
            'createDelegation',
            nodeWithArgs('createStudyDelegation', {
                institutionId,
                delegation: {
                    binderId,
                    ...delegation
                },
            }, [
                'id',
                node('user', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('rolesManagement', ['id', 'name']),
                'taskIds',
                'startDate',
                'endDate'
            ]));
        
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to add user delegations'));
            } else {
                dispatch({
                    type: ADD_STUDY_DELEGATION,
                    payload: results.data[query.name],
                }).then(dispatch(loadStudySignatures(binderId))
                    .then(dispatch(retrieveStudyAuditLogData(binderId))));
                dispatch(loadSignatureExpectations(binderId));
            }
        });
    };
}

export function updateStudyDelegation(binderId, delegation) {
    return (dispatch, getState) => {
        const state = getState();
        const { study: { id: studyId } = {}} = state;
        const institutionId = binderInstitutionIdSelector(state);
        const query = studyNodeWrapper(
            studyId,
            'updateDelegation',
            nodeWithArgs('updateStudyDelegation', {
                institutionId,
                delegation: {
                    binderId,
                    ...delegation,
                },
            }, [
                'id',
                node('rolesManagement', ['id', 'name']),
                node('user', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                'taskIds',
                'startDate',
                'endDate',
            ]));

        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to update delegation'));
            } else {
                dispatch({
                    type: UPDATE_STUDY_DELEGATION,
                    payload: results.data[query.name],
                }).then(dispatch(retrieveStudyAuditLogData(binderId)));
                dispatch(loadSignatureExpectations(binderId));
            }
        });
    };
}

export function changeStudyPI(outgoingPI, incomingPI) {
    return (dispatch, getState) => {
        const state = getState();
        const { study: { id: studyId } = {}} = state;
        const institutionId = binderInstitutionIdSelector(state);
        const query = studyNodeWrapper(
            studyId,
            'changePI',
            nodeWithArgs('changeStudyPI', {
                outgoingPI,
                incomingPI,
                institutionId,
            }, [
                'id',
                node('user', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('rolesManagement', ['id', 'name']),
                'taskIds',
                'startDate',
                'endDate',
            ]));

        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to change study PI'));
            } else {
                dispatch(loadStudyDelegations(outgoingPI.binderId));
                dispatch(loadSignatureExpectations(outgoingPI.binderId));
            }
        });
    };
}

export function deleteStudyDelegation(binderId, delegationId) {
    return (dispatch, getState) => {
        const state = getState();
        const { study: { id: studyId } = {}} = state;
        const institutionId = binderInstitutionIdSelector(state);
        const query = studyNodeWrapper(
            studyId,
            'deleteDelegation',
            nodeWithArgs('deleteStudyDelegation', {
                id: delegationId,
                binderId,
                institutionId,
            }, [
                'id',
            ]));
        
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to remove delegation'));
            } else {
                dispatch({
                    type: DELETE_STUDY_DELEGATION,
                    payload: results.data[query.name],
                }).then(dispatch(retrieveStudyAuditLogData(binderId)));
                dispatch(loadSignatureExpectations(binderId));
            }
        });
    };
}

export function unloadStudyTasksAndDelegations() {
    return {
        type: UNLOAD_STUDY_TASKS_AND_DELEGATIONS,
    };
}
